<template>
  <div class="role-edit">
    <Row :gutter="16">
      <i-col span="12">
        <Form ref="editForm" :model="roleModel"
          :rules="modelValidate"
          label-position="left"
          :label-width="140">
          <FormItem label="名称" prop="name">
            <Input v-model="roleModel.name" placeholder="输入名称" />
          </FormItem>
          <FormItem label="用户类型" prop="type">
            <Select v-model="roleModel.type" filterable>
              <Option v-for="(tp,idx) in $common.getEnumSelect($common.userType)" :key="idx" :value="parseInt(tp.key)">{{tp.value}}</Option>
            </Select>
          </FormItem>
          <FormItem label="系统预设">
            <i-switch v-model="roleModel.isReserved" :disabled="true" size="large">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </FormItem>
          <FormItem>
            <Button type="primary" size="large" long @click="submit">保存</Button>
          </FormItem>
        </Form>
      </i-col>
      <i-col span="8">
      </i-col>
    </Row>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'role-edit',
  props: {
  },
  data () {
    return {
      loading: false,
      roleModel: {
        name: null,
        type: null,
        isReserved: false,
        parent: null
      },
      modelValidate: {
        name: [
          { required: true, message: '请填写名称', trigger: 'blur' }
        ],
        type: [
          { type: 'number', message: '请选择用户类型', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
  },
  mounted () {
    if (this.$route.params.role) {
      this.roleModel = this.$route.params.role
    } else {
      this.roleModel = {
        name: null,
        type: null,
        isReserved: false,
        parent: null
      }
    }
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    async submit () {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          await Api.Role.updateRole(this.roleModel)
            .then((payload) => {
              console.log('suc', payload)
              this.$Message.success('修改成功!')
              this.loading = false
              this.$Spin.hide()
            })
            .catch(err => {
              console.log('err', err)
              this.$Message.error('提交失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
            })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.avatar-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  .student-avatar {
    width: 200px;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #efefef;
  }
}
</style>
